module.exports = __webpack_public_path__ + "static/media/horario.f7b651ad.svg";